module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-checkbox', {
    model: {
      value: (_vm.hasError),
      callback: function($$v) {
        _vm.hasError = $$v
      },
      expression: "hasError"
    }
  }, [_vm._v("Show errors")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "type": {
        'is-danger': _vm.hasError
      },
      "message": {
        'Username is not available': _vm.hasError
      }
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password",
      "type": {
        'is-danger': _vm.hasError
      },
      "message": [{
          'Password is too short': _vm.hasError
        },
        {
          'Password must have at least 8 characters': _vm.hasError
        }
      ]
    }
  }, [_c('b-input', {
    attrs: {
      "value": "123",
      "type": "password",
      "maxlength": "30"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc2bf04"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExObjectSyntax.vue
// module id = 1075
// module chunks = 5 129